/**
 * landing.js — trang giới thiệu dạng onepage (about.html): chấm điều hướng + hiện dần từng màn.
 *
 * Markup: main[data-landing] chứa các section[data-lp-section][id] (thêm data-lp-theme="dark" cho màn
 *         nền tối), nav[data-lp-dots] > a[href="#id"] (+ [data-lp-count]), phần tử [data-lp-reveal].
 *
 * Vì sao như vậy:
 *   · Cuộn dừng từng màn là scroll-snap của CSS (page/_about.scss) — không chặn wheel / không tự cuộn bằng
 *     JS, nên bàn phím, trackpad, kéo thanh cuộn, Ctrl+F đều chạy như trang thường.
 *   · Chấm là link thật tới #id: không có JS vẫn nhảy được; file này chỉ tô màn đang xem (aria-current),
 *     đổi số đếm và đổi màu chấm khi màn hiện tại là màn tối.
 *   · "Màn đang xem" = màn cắt vạch giữa khung nhìn (rootMargin −50% / −50%) — màn cao hơn khung nhìn
 *     vẫn được tính đúng suốt lúc cuộn bên trong nó.
 *   · Ẩn để hiện dần chỉ bật khi đã có IntersectionObserver (.is-ready); màn đang nằm trong khung nhìn lúc
 *     tải (mở trang kèm #cua-hang) được đánh dấu hiện NGAY, nếu không sẽ chớp tắt rồi mới hiện.
 *
 * WP: giữ nguyên file; page-about.php in đúng các data-* trên.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var root = document.querySelector('[data-landing]');
    if (!root) return;

    var sections = [].slice.call(root.querySelectorAll('[data-lp-section]'));
    var dots = root.querySelector('[data-lp-dots]');
    var links = dots ? [].slice.call(dots.querySelectorAll('a[href^="#"]')) : [];
    var count = dots ? dots.querySelector('[data-lp-count]') : null;
    if (!sections.length || !('IntersectionObserver' in window)) return;

    function pad(n) {
        return n < 10 ? '0' + n : String(n);
    }

    function setCurrent(section) {
        links.forEach(function (link) {
            if (link.getAttribute('href') === '#' + section.id) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
        });
        if (count) count.textContent = pad(sections.indexOf(section) + 1);
        if (dots) dots.classList.toggle('is-on-dark', section.getAttribute('data-lp-theme') === 'dark');
    }

    // Màn đã nằm trong khung nhìn lúc tải: hiện ngay, không chờ observer (tránh chớp)
    sections.forEach(function (section) {
        var box = section.getBoundingClientRect();
        if (box.top < window.innerHeight && box.bottom > 0) section.classList.add('is-inview');
    });
    root.classList.add('is-ready');

    var reveal = new IntersectionObserver(
        function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-inview');
                reveal.unobserve(entry.target);
            });
        },
        { threshold: 0.15 }
    );

    var spy = new IntersectionObserver(
        function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) setCurrent(entry.target);
            });
        },
        { rootMargin: '-50% 0px -50% 0px' }
    );

    sections.forEach(function (section) {
        if (!section.classList.contains('is-inview')) reveal.observe(section);
        spy.observe(section);
    });
})();
